'use client';

import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useUser } from 'src/hooks/use-user';

import { getPlanAccessContext } from 'src/utils/plan/plan-access';
import { planResearchSearchesPerMonth } from 'src/utils/plan/plan-research';

import { researchKeys } from 'src/query-keys/research';
import { readResearchUsage } from 'src/actions/research';

/**
 * 이번 달 Research 쓴 수 · 한도 — 한도가 있는 플랜만 묻는다(읽기만 · 세지 않는다).
 * Research 화면이 새 검색어를 세면 같은 캐시를 갈아 끼운다(`ResearchQuotaProvider`) — 사이드바 셈이 바로 따라간다.
 * @returns 무제한 · Research 없음 · 아직 모름(읽는 중 · 실패)이면 `null`
 */
export function useResearchUsage(): { used: number; limit: number } | null {
  const user = useUser();
  const { planId } = useMemo(() => getPlanAccessContext(user), [user]);
  const workspaceId = String(user?.lastWorkspace ?? '').trim();
  const planLimit = planResearchSearchesPerMonth(planId);
  const metered = typeof planLimit === 'number' && planLimit > 0;
  const query = useQuery({
    queryKey: researchKeys.usage(workspaceId),
    enabled: metered && Boolean(workspaceId),
    staleTime: 60_000,
    queryFn: () => readResearchUsage(),
  });
  const reply = query.data;
  if (!metered || !reply?.metered || typeof reply.limit !== 'number' || reply.limit <= 0) return null;
  return { used: reply.used, limit: reply.limit };
}
